import React from 'react';

const Foldable = (props) => {
  return React.Children.map(props.children, (child,i) => {
    return (
      <div className="Foldable">
        <div onClick={ () => props.onClick ? props.onClick(i) : null }>
          { child.props.children[0] }
        </div>
        <div style={{
          maxHeight: props.selected === i ? (props.maxHeight ? props.maxHeight : 500) : 0,
          overflow: 'hidden',
          transition: 'max-height 0.3s'
        }}>
          { child.props.children.slice(1) }
        </div>
      </div>
    );
  });
};

export default Foldable;



// WEBPACK FOOTER //
// ./src/Foldable.js